<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="mgr_5"> <CustomDatePicker v-model="from_date" /> ~ <CustomDatePicker v-model="to_date" /> </span>
				<span class="int_type mgr_5">
					<select v-model="user_id">
						<option value="">All</option>
						<option v-for="user in users" :value="user.user_id" :selected="user_id === user.user_id" v-bind:key="user.user_id">{{ user.name }}</option>
					</select>
				</span>
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
			</div>
		</div>
		<div class="fixed-table-container">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl">
					<colgroup>
						<col style="width: 1%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
					</colgroup>
					<thead>
						<tr>
							<th>No</th>
							<th>Subject</th>
							<th>Send Date</th>
							<th>Send Address</th>
							<th>Send User</th>
							<th>Source</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(mail, index) in list" v-bind:key="index" @click="showMailDetail(index)">
							<td class="al_center">{{ mail.mail_no }}</td>
							<td>{{ mail.subject }}</td>
							<td class="al_center">{{ mail.crtDt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
							<td>{{ mail.send_address }}</td>
							<td>{{ mail.send_user ? mail.send_user.name : '' }}</td>
							<td>{{ mail.source }}</td>
						</tr>
					</tbody>
				</table>
				<jpa-paging v-if="page" v-bind:page="page" v-on:gotoPage="gotoPage"></jpa-paging>
			</div>
		</div>
		<mailDetail v-if="mailModal" :mail="selectMail" @close="mailModal = false" />
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { apiMailSearch } from '@/api/mail/mail';
import JpaPaging from '@/components/common/JpaPaging';
import { apiSimpleUserList } from '@/api/basicinfo/user';
import MailDetail from '@/views/report/MailDetail';
import { today } from '@/utils/date';

export default {
	name: 'MailLog',
	data() {
		return {
			from_date: today(),
			to_date: today(),
			user_id: '',
			list: [],
			list_count: 0,
			page: null,
			users: [],
			mailModal: false,
			selectMail: null,
		};
	},
	components: {
		MailDetail,
		JpaPaging,
		CustomDatePicker,
	},
	computed: {
		session_user() {
			return this.$session.get('user');
		},
	},
	methods: {
		search(pageNumber) {
			const param = this.getParam(pageNumber);

			apiMailSearch(param).then(res => {
				this.list = res.data.content;
				this.list_count = res.data.totalElements;
				this.page = res.data;
			});
		},

		getParam(pageNumber) {
			return {
				from_date: this.from_date,
				to_date: this.to_date,
				crt_user: this.user_id,
				sort: 'crtDt,desc',
				page: pageNumber,
			};
		},
		gotoPage(pageNumber) {
			this.search(pageNumber);
		},

		showMailDetail(index) {
			this.selectMail = this.list[index];
			this.mailModal = true;
		},
	},
	mounted() {
		this.$route.query.from_date && (this.from_date = this.$route.query.from_date);
		this.$route.query.to_date && (this.to_date = this.$route.query.to_date);
		this.$route.query.user_id && (this.user_id = this.$route.query.user_id);
		let param = {
			user_id: this.session_user.admin_yn === 'Y' ? '' : this.session_user.user_id,
			active_yn: 'Y',
		};

		apiSimpleUserList(param).then(res => {
			this.users = res.data;
		});

		// this.search();
	},
};
</script>
